import { gql } from '@apollo/client';

export const GET_PORTFOLIO_NAME = gql`
  query GetPortfolioName($id: ID!) {
    portfolio: getPortfolio(id: $id) {
      id
      name
    }
  }
`;
